import "./Atsiliepimai.css";

const Atsiliepimai = () => {
  return (
    <div className="atsiliepimai">
      <div className="facebook-responsive">
        <iframe
          title="atsiliepimas-1"
          className="atsiliepimas"
          src="https://www.facebook.com/plugins/post.php?href=https%3A%2F%2Fwww.facebook.com%2Flineta.meizyte.75%2Fposts%2Fpfbid02NfG4VNvca3SdXN76KPpZPmA1jouTdthK2WGwubtiYyaSK8w29FpUh1GHMfMFwh3ql&show_text=true&width=500"
          width=""
          height=""
          allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"
        ></iframe>
      </div>
      <div className="facebook-responsive">
        <iframe
          className="atsiliepimas"
          title="atsiliepimas-2"
          src="https://www.facebook.com/plugins/post.php?href=https%3A%2F%2Fwww.facebook.com%2Fvita.navickyte%2Fposts%2Fpfbid02F8XdDg6nBWGeSn8njKMJGZUkR8mNiHJHXPX3pZ4i1A2CM8qxMn4tF6jAEBsJg9VXl&show_text=true&width=500"
          width=""
          height=""
          allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"
        ></iframe>
      </div>
      <div className="facebook-responsive">
        <iframe
          className="atsiliepimas"
          title="atsiliepimas-3"
          src="https://www.facebook.com/plugins/post.php?href=https%3A%2F%2Fwww.facebook.com%2Flina.uktveryte%2Fposts%2Fpfbid0hdt3s63U7P92fEt8Gv9aPzmqQhdz6wH5gD6uSgUn41fMCJ3xjNWd5bL5Nc7pUZirl&show_text=true&width=500"
          width=""
          height=""
          allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"
        ></iframe>
      </div>
      <div className="facebook-responsive">
        <iframe
          className="atsiliepimas"
          title="atsiliepimas-4"
          src="https://www.facebook.com/plugins/post.php?href=https%3A%2F%2Fwww.facebook.com%2Fgi.aureja%2Fposts%2Fpfbid0wRJGZP4dwDrgEHjkbrQuM6XZoKNUYtJM5QKMcg51AGUkT72YRqtq7Ek292Kax8W1l&show_text=true&width=500"
          width=""
          height=""
          allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"
        ></iframe>
      </div>
      <div className="facebook-responsive">
        <iframe
          className="atsiliepimas"
          title="atsiliepimas-5"
          src="https://www.facebook.com/plugins/post.php?href=https%3A%2F%2Fwww.facebook.com%2Fvaida.nesvarb%2Fposts%2Fpfbid0XDQJc5wokAA3BTuSnnGxpf8XW5GJxddcfBSzxWCqjiFhhU1UGzRyqUNA8351q3TUl&show_text=true&width=500"
          width=""
          height=""
          allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"
        ></iframe>
      </div>
      <div className="facebook-responsive">
        <iframe
          className="atsiliepimas"
          title="atsiliepimas-6"
          src="https://www.facebook.com/plugins/post.php?href=https%3A%2F%2Fwww.facebook.com%2Fievavis13%2Fposts%2Fpfbid0yqk2r1eopZRKCY1jAr3ECrvnCjxKArWuXWq3ogxvnw5XSazPxwVu1Fzy1VibNfNgl&show_text=true&width=500"
          width=""
          height=""
          allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"
        ></iframe>
      </div>
    </div>
  );
};

export default Atsiliepimai;
